const isProduction = process.env.NODE_ENV === 'production';

export default (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION__ && !isProduction
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : f => f);
